<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-education-level-dialog-create
          v-if="$hasPermissionTo(['create education levels'])"    
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in education level here"
          append-icon="search"
          label="Search Education Level"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="educationLevels"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.action="{ item }">
        <setup-education-level-dialog-edit
          v-if="$hasPermissionTo(['update education levels'])"    
          :education-level="item"
          @updated="loadData"
        />
        <span class="mx-1" />
        <setup-education-level-dialog-delete
          v-if="$hasPermissionTo(['delete education levels'])"    
          :education-level="item"
          @deleted="loadData"
        />        
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupEducationLevelDialogCreate: () => import('@/components/hris/setup/education/level/DialogCreate'),
      SetupEducationLevelDialogDelete: () => import('@/components/hris/setup/education/level/DialogDelete'),
      SetupEducationLevelDialogEdit: () => import('@/components/hris/setup/education/level/DialogEdit'),
    },
    data () {
      return {
        headers: [
          {
            text: 'Level',
            align: 'left',
            value: 'level',
          },
          {
            text: 'Education Level',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Description',
            align: 'left',
            value: 'description',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
        educationLevels: [],
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.$api.hrisEducationLevels().list()
          .then(res => {
            this.educationLevels = res.data

            this.tableLoading = false
          })
      },
    },
  }
</script>
